import { useEffect } from "react";
import { useAuth, useClerk } from "@clerk/react";
import { Navigate, useLocation } from "react-router-dom";
import { useEntitlement } from "../lib/EntitlementContext";

export const RequireStudioAccess = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const { openSignIn } = useClerk();
  const location = useLocation();
  const { status, hasActiveEntitlement, isEntitlementLoading } = useEntitlement();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      openSignIn();
    }
  }, [isLoaded, isSignedIn, openSignIn]);

  if (!isLoaded || isEntitlementLoading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center text-zinc-400">
        Checking access...
      </div>
    );
  }

  if (!isSignedIn || status === "signed_out") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasActiveEntitlement) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
